import React from 'react';
import { motion } from 'framer-motion';
import { Modal } from './Modal';
import { buttonHover, buttonTap } from '../../ui/animations';

export function CorporateOfferModal({ dispatch }) {
  return (
    <Modal title="Corporate Investment Offer" onClose={() => dispatch({ type: 'DECLINE_CORPORATE_INVESTMENT' })}>
      <div style={{ textAlign: 'center', marginBottom: 16 }}>
        <div style={{ fontSize: 48, marginBottom: 8 }}>💼</div>
        <div style={{ fontSize: 18, fontWeight: 700, color: 'var(--text)', marginBottom: 4 }}>
          CannCorp Inc.
        </div>
        <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>
          Corporate Investment Proposal
        </div>
      </div>

      <div style={{ background: 'var(--border-light)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 14, marginBottom: 10 }}>
        <div style={{ fontSize: 13, color: 'var(--text)', lineHeight: 1.6, marginBottom: 12 }}>
          CannCorp Inc. has been impressed by your operation and wants to invest.
          They're offering <span style={{ color: 'var(--green)', fontWeight: 700 }}>$1,000,000</span> in
          exchange for <span style={{ color: 'var(--yellow)', fontWeight: 700 }}>25% equity</span> in your company.
        </div>

        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>What you get:</div>
        <ul style={{ fontSize: 12, color: 'var(--text)', paddingLeft: 20, marginBottom: 12, lineHeight: 1.8 }}>
          <li><span style={{ color: 'var(--green)' }}>$1,000,000 cash injection</span></li>
          <li>All facility rooms unlocked immediately</li>
          <li>Access to scientist hiring for R&D</li>
          <li>+1 brand value per week from corporate backing</li>
          <li>Reputation floor — never drops below 10</li>
        </ul>

        <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 6 }}>What it costs:</div>
        <ul style={{ fontSize: 12, color: 'var(--yellow)', paddingLeft: 20, lineHeight: 1.8 }}>
          <li>25% equity — CannCorp owns a quarter of your company</li>
          <li>Quarterly directives — mandatory objectives with fines or rep penalties on failure</li>
          <li>Board satisfaction tracking — let it fall too low and face a hostile takeover</li>
          <li>Black market restrictions — CannCorp may ban illegal sales if board turns hostile</li>
        </ul>
      </div>

      <div style={{ background: 'var(--border-light)', border: '1px solid var(--border)', borderRadius: 'var(--radius)', padding: 12, marginBottom: 14 }}>
        <div style={{ fontSize: 11, color: 'var(--text-muted)', marginBottom: 6 }}>Reviewer bias when corporate-backed:</div>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6 }}>
          {[
            { name: 'Super Terp Mag', bias: -15 },
            { name: 'GovernmentKush', bias: -12 },
            { name: 'Dank Daily', bias: -8 },
            { name: 'Bud Buyer\'s Guide', bias: +3 },
            { name: 'High Times West', bias: +5 },
            { name: 'Dispensary Review', bias: +8 },
          ].map(r => (
            <span
              key={r.name}
              style={{
                fontSize: 10,
                padding: '2px 7px',
                borderRadius: 10,
                background: r.bias < 0 ? 'rgba(220,60,60,0.15)' : 'rgba(60,180,80,0.15)',
                color: r.bias < 0 ? 'var(--red)' : 'var(--green)',
                border: `1px solid ${r.bias < 0 ? 'rgba(220,60,60,0.3)' : 'rgba(60,180,80,0.3)'}`,
              }}
            >
              {r.name} {r.bias > 0 ? '+' : ''}{r.bias}
            </span>
          ))}
        </div>
        <div style={{ fontSize: 10, color: 'var(--text-dim)', marginTop: 6 }}>
          You can buy out CannCorp's stake later — price scales with your total revenue.
        </div>
      </div>

      <div style={{ display: 'flex', gap: 8 }}>
        <motion.button
          className="btn btn-primary"
          style={{ flex: 1, padding: '10px 14px', fontSize: 14 }}
          onClick={() => dispatch({ type: 'ACCEPT_CORPORATE_INVESTMENT' })}
          whileHover={buttonHover}
          whileTap={buttonTap}
        >
          Accept — Take the $1M
        </motion.button>
        <motion.button
          className="btn btn-secondary"
          style={{ flex: 1, padding: '10px 14px', fontSize: 14 }}
          onClick={() => dispatch({ type: 'DECLINE_CORPORATE_INVESTMENT' })}
          whileHover={buttonHover}
          whileTap={buttonTap}
        >
          Decline — Stay Independent
        </motion.button>
      </div>
    </Modal>
  );
}
